// extracted by mini-css-extract-plugin
export var measureBox = "_2p-0";